import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// NOTE: theme.css is reserved for future white-label solution for booksellers (if needed)
// For now, we use index.css only for all color theming
// import './styles/theme.css'
import './styles/fonts.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
